<template>
    <div class="w-full relative rounded-6 border border-primary-20 min-h-40 px-16 py-8 flex flex-wrap cursor-text z-top">
        <span class="self-center text-primary-80 mr-8">Bcc</span>

        <div v-for="(bcc, index) in bccItems"
             :key="'bcc'+index"
             :class="validateEmail(bcc.title) ? 'border border-primary-20 hover:bg-primary-5' : 'bg-semantic-error hover:bg-semantic-error-dark text-white'"
             class="flex items-center rounded-32 text-body-sm font-semibold mr-8 cursor-pointer"
             @click="unselectBcc(index)"
        >
            <span class="pl-8 mr-8 py-2">{{ bcc.title }}</span>

            <button
                :class="validateEmail(bcc.title) ? 'text-primary-60 hover:text-primary' : 'text-white hover:text-primary-5'"
                class="mr-4 trans-ease"
            >
                <svg-icon size="16" type="cancel-filled" />
            </button>
        </div>

        <input
            id="bcc-search-input"
            ref="bccSearch"
            v-model="filterText"
            autofocus
            class="flex-1 h-22 placeholder-primary-80 outline-none"
            type="text"
            @blur="removeFocus"
            @focus="setFocus"
            @keydown.enter.prevent="handleEnter"
            @keydown.delete="handleDelete"
        >

        <div v-if="query"
             class="absolute left-0 top-full ml-48 bg-white rounded-6 -mt-4 py-6 shadow min-w-400 w-auto">
            <ul>
                <li>
                    <button class="group px-16 h-40 leading-none hover:bg-primary-5 flex items-center w-full"
                            @click="createNewBcc"
                    >
                        <span class="mr-auto">{{ query }}</span>
                        <span class="font-semibold inline">
                            {{ $t('general.add') }}
                        </span>
                    </button>
                </li>
                <li v-for="user in users">
                    <button class="group px-16 h-40 leading-none hover:bg-primary-5 flex items-center w-full"
                            @click="createNewBcc(user.email)"
                    >
                        <span class="mr-auto">{{ user.email }}</span>
                        <span class="font-semibold inline">
                            {{ $t('general.add') }}
                        </span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import SvgIcon from './SvgIcon.vue';
import {mapState} from "pinia";
import {useUsersStore} from '../../state/modules/users';

export default {
    components: {SvgIcon},
    data: function () {
        return {
            bccItems: [],
            isFocussed: false,
            filterText: '',
        };
    },
    computed: {
        ...mapState(useUsersStore, ['allUsersExceptMe']),
        users() {
            return this.allUsersExceptMe.filter(user => {
                return !this.bccItems.includes(user) && user.name.toLowerCase().includes(this.query);
            })
        },
        query() {
            return this.filterText.trim().toLowerCase();
        },
    },
    methods: {
        setFocus() {
            this.isFocussed = true;
        },
        removeFocus() {
            this.isFocussed = false;
        },
        createNewBcc(event = null) {
            const item = typeof event === 'string' ? event : this.query;

            //For now bccItems don't have an id,
            //This code can be expanded so a search could be done with email addresses
            this.bccItems.push({
                title: item || this.query,
            });

            this.filterText = '';

            this.$nextTick(() => this.$refs.bccSearch.focus());
        },
        unselectBcc(bccIndex) {
            this.bccItems.splice(bccIndex, 1);

            this.$nextTick(() => this.$refs.bccSearch.focus());
        },
        validateEmail(email) {
            let re = /\S+@\S+\.\S+/;

            return re.test(email);
        },
        handleDelete(event) {
            if (event.code !== 'Backspace') {
                return;
            }

            if (!this.filterText.length) {
                this.bccItems.pop();
            }
        },
        handleEnter(event){
            if (event.code !== 'Enter') {
                return;
            }

            this.createNewBcc();
        }
    },
    watch: {
        bccItems: function (value){
            this.$emit('input', value.map(item => item.title).join(';'));
        }
    }
};
</script>
